import Role from "../models/Role";
export const ACLMixin = {
  data() {
    return {
      role: this.initialize(),
      permissions: [],
      loading: false
    }
  },
  methods: {
    initialize() {
      return new Role({
        name: null,
        label: null,
        permissions: [],
      })
    },
    fetch_all_permissions() {
      this.loading = true
      Role.permissions(permissions => {
        this.permissions = permissions
        this.loading = false
      });
    }
  },
  created() {
    this.fetch_all_permissions();
  }
}
